import { trigger, state, style, transition, animate } from '@angular/animations';

export const slideToggle = trigger('slideToggle', [
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate('300ms ease-out', style({ height: '*', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ height: 0, opacity: 0 }))
  ])
]);

export const slideToggleLocation = trigger('slideToggleLocation', [
  state('closed', style({ height: 0, opacity: 0, overflow: 'hidden' })),
  state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
    transition('closed => open', [
    style({ overflow: 'hidden' }),
    animate('300ms ease-out')
  ]), 
    transition('open => closed', [
    style({ overflow: 'hidden' }),
    animate('200ms ease-in')
  ])
]);

